import React, { useState } from 'react';
import { motion, useMotionValueEvent, useScroll, useTransform } from 'framer-motion';

/** Scroll progress as a sweeping second hand; doubles as back-to-top. */
export function ScrollProgress() {
  const {
    scrollYProgress
  } = useScroll();
  const rotate = useTransform(scrollYProgress, [0, 1], [0, 360]);
  const [visible, setVisible] = useState(false);
  useMotionValueEvent(scrollYProgress, 'change', v => setVisible(v > 0.06));
  return <button type="button" onClick={() => window.scrollTo({
    top: 0
  })} aria-label="Back to top" tabIndex={visible ? 0 : -1} className={`fixed bottom-5 right-5 z-30 grid h-12 w-12 place-items-center rounded-full border border-stone bg-white/90 backdrop-blur transition-[opacity,transform] duration-200 ease-out hover:border-gold ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-2 opacity-0'}`} data-id="element-400" data-mp="341lvsyrlygn1">
      <svg viewBox="0 0 40 40" className="h-9 w-9" aria-hidden="true" data-id="element-401" data-mp="o84r1kq8vxun">
        <circle cx="20" cy="20" r="17" fill="none" stroke="#B8976A" strokeWidth="0.75" data-id="element-402" data-mp="2ukrqpqdojpc9" />
        {Array.from({
        length: 12
      }).map((_, i) => {
        const a = i * 30 * Math.PI / 180;
        return <line key={i} x1={20 + 17 * Math.sin(a)} y1={20 - 17 * Math.cos(a)} x2={20 + 14.5 * Math.sin(a)} y2={20 - 14.5 * Math.cos(a)} stroke="#B8976A" strokeWidth={i === 0 ? 1.4 : 0.8} data-id="element-403" data-mp="34j7ky2807epz" data-mpi={i} />;
      })}
      </svg>
      <motion.span style={{
      rotate
    }} className="absolute inset-0 grid place-items-center" aria-hidden="true" data-id="element-404" data-mp="2gqh9du40ixg8">
        <span className="block h-[15px] w-px -translate-y-[7px] bg-charcoal" data-id="element-405" data-mp="2lpttw87evsfn" />
      </motion.span>
    </button>;
}